import { METHOD, request } from "./../../../utils/request";
import { Categories } from "./../../api";

async function getAll(params) {
  return request(Categories.getAll, METHOD.GET, params);
}
async function getDetails(params) {
  return request(Categories.getDetails, METHOD.GET, params);
}
async function getDialog(params) {
  return request(Categories.getDialog, METHOD.GET, params);
}

async function add(data) {
  return request(Categories.add, METHOD.POST, data);
}
async function update(data) {
  return request(Categories.update, METHOD.POST, data);
}

async function changeActivationType(data) {
  return request(Categories.changeActivationType, METHOD.POST, data);
}

async function finalDelete(data) {
  return request(Categories.finalDelete, METHOD.POST, data);
}
async function deleteImage(data) {
  return request(Categories.deleteImage, METHOD.POST, data);
}

export default {
  getAll,
  getDetails,
  getDialog,
  add,
  update,
  changeActivationType,
  finalDelete,
  deleteImage,
};
